// Hash routes: `#/<page>/<ref>/<ref>?k=v`. The first segment names the page; every later segment is a
// ref whose prefix names its param, and non-ref params ride in the query.
// `#/container/org_x/ctr_y/mbx_z?host=acme.com` -> { name: 'container', query: { org: 'org_x', container: 'ctr_y', mailbox: 'mbx_z', host: 'acme.com' } }.
// Each app has its own routes: the mail app at `/` and the admin app at `/admin`, whose pages are
// `tpl-admin-<page>`. An empty hash is the app's home: `inbox` unless the caller says otherwise.

// Ref prefix -> route param, in the order routeHref writes them.
const REF_PARAMS = { org: 'org', ctr: 'container', mbx: 'mailbox', usr: 'user' }

const refParam = (segment) => segment[3] === '_' && REF_PARAMS[segment.slice(0, 3)]

export function parseRoute(hash, home = 'inbox') {
  const raw = (hash || '').replace(/^#/, '')
  const [pathPart, queryPart = ''] = raw.split('?')
  const path = pathPart.split('/').filter(Boolean).map(decodeURIComponent)
  const query = {}
  for (const segment of path.slice(1)) {
    const param = refParam(segment)
    if (param) query[param] = segment
  }
  Object.assign(query, Object.fromEntries(new URLSearchParams(queryPart)))
  return { path, query, name: path[0] || home }
}

// routeHref('container', { org, container, mailbox: 'mbx_z', host: '' }) -> '#/container/org_x/ctr_y/mbx_z'; empty values are dropped.
// An empty name is the app's home: routeHref('', { tab: 'users' }) -> '#/?tab=users'.
export function routeHref(name, params = {}) {
  const refs = Object.values(REF_PARAMS).filter((param) => params[param])
  const segments = [name, ...refs.map((param) => params[param])].filter(Boolean).map(encodeURIComponent)
  const rest = Object.entries(params).filter(([key, value]) => value && !refs.includes(key))
  const query = new URLSearchParams(rest).toString()
  return `#/${segments.join('/')}${query ? `?${query}` : ''}`
}
